import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Tag } from "../Types/tagsType";

export const tagsApi = createGenericApiSlice<Tag>({
	reducerPath: "tagsApi",
	tag: TagTypes.Tag,
	endpoint: "tags",
});

export const {
	useGetAllQuery: useGetTagsQuery,
	useGetByIdQuery: useGetTagByIdQuery,
	useCreateMutation: useCreateTagMutation,
	useUpdateMutation: useUpdateTagMutation,
	useDeleteMutation: useDeleteTagMutation,
} = tagsApi;
